import {Component, Input} from '@angular/core';
import {Audit} from "../audit";

@Component({
    selector: 'audit-list',
    providers: [],
    templateUrl: 'audit-list.component.html'
})
export class AuditListComponent{

    @Input()
    data: Audit;

    getKeys(parameters){
        return Object.keys(parameters);
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit-list/audit-list.component.ts